var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 58,
    viewBox: "0 0 295 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M295 0H249.615C207.109 24.6754 159.928 40.2236 111.079 45.6532L0 58H295V0Z",
    fill: "#00332D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBg);
export default __webpack_public_path__ + "static/media/greenBg.db5455cf77a5135d21db7603f21bf33d.svg";
export { ForwardRef as ReactComponent };